export default function CardSection({ icon, title, children }) {
    return (
        <div className="card-minimal">
            <div className="header-minimal">
                <i className="material-icons">{icon}</i>
                <span>{title}</span>
            </div>
            <div className="card-body">{children}</div>
        </div>
    );
}
